import Velocity from 'velocity-animate'
import 'velocity-animate/velocity.ui'
import logger from '../logger'
import {
  isFunction,
  merge,
} from 'lodash-es'

// /////////////////////////
// Page Scroll Mixin //
// /////////////////////////

export default {
  scrollTop() {
    // Scroll the application to the top
    logger('Scrolling the application to the top', 'info')()
    const mySequence = [{
      e: document.querySelector('body'),
      p: 'scroll',
      o: {
        duration: 750,
        easing: 'easeInOutQuad',
        complete: () => {
          logger('Application at the top', 'info')()
        },
      },
    }]

    Velocity.RunSequence(mySequence)
  },

  scrollToEl(element, opts, cb) {
    if (!element) return
    const target = this?.root?.querySelector(element);
    if (!target) return;
    const vopts = {
      duration: 750,
      offset: -16,
      easing: 'easeInOutQuad',
      complete: () => {
        if (isFunction(cb)) cb.call(this)
      },
    }

    const mySequence = [{
      e: target,
      p: 'scroll',
      o: merge(vopts, opts),
    }]

    Velocity.RunSequence(mySequence)
  },
}
